export default __webpack_public_path__ + "static/media/appLogo.0b2710fa.svg";